import { api } from '@dpgradio/creative'

const BASE = 'game/bingo'

export function fetchGame(gameId) {
  return api.request().get(`${BASE}/games/${gameId}`)
}

export function fetchRound(roundId) {
  return api.request().get(`${BASE}/rounds/${roundId}`)
}

export async function createCard(gameId) {
  try {
    return await api.request().post(`${BASE}/games/${gameId}/cards`)
  } catch (e) {
    const match = e.message?.match(/"card_id"\s*:\s*(\d+)/)
    if (match) {
      return await fetchCard(match[1])
    }
    throw e
  }
}

export function fetchCard(cardId) {
  return api.request().get(`${BASE}/cards/${cardId}`)
}

export function markSquare(cardId, squareId) {
  return api.request().post(`${BASE}/cards/${cardId}/squares/${squareId}/mark`)
}

export function unmarkSquare(cardId, squareId) {
  return api.request().post(`${BASE}/cards/${cardId}/squares/${squareId}/unmark`)
}

export function claimBingo(cardId) {
  return api.request().post(`${BASE}/cards/${cardId}/claim_bingo`)
}
